<template>
  <div class="drop-zone" @drop.prevent="handlePortfolioSelected" :id="id">
    <div class="spinner-root" v-if="isLoading">
      <b-spinner />
      <span class="info">{{ $t("portfolioManager.dropzone.loading") }}</span>
    </div>
    <div class="controls" v-else>
      <div class="custom-title" v-if="isPortfolioManager">
        {{ $t("portfolioManager.dropzone.dropTitle") }}
      </div>
      <input
        type="file"
        hidden
        :id="`${id}-file-input`"
        @change="handlePortfolioSelected"
      />
      <div class="btns-container">
        <b-button type="file" @click="invokeExplorer">
          <upload-icon /> {{ $t("portfolioManager.dropzone.importBtn") }}
        </b-button>
        <b-button
          v-b-modal.modal.create-portfolio-modal
          v-if="isPortfolioManager"
        >
          <pencil-icon />
          {{ $t("portfolioManager.dropzone.createPortfolio") }}
        </b-button>
        <create-portfolio-modal />
      </div>
      <span class="subtle-text">{{
        $t("portfolioManager.dropzone.dropCSV")
      }}</span>
    </div>
  </div>
</template>

<script>
import CreatePortfolioModal from "./modals/CreatePortfolioModal.vue";
import PencilIcon from "vue-material-design-icons/Pencil.vue";
import UploadIcon from "vue-material-design-icons/Upload.vue";
const events = ["dragenter", "dragover", "dragleave", "drop"];
export default {
  name: "dropzone",
  components: { CreatePortfolioModal, UploadIcon, PencilIcon },
  props: {
    isLoading: Boolean,
    isPortfolioManager: Boolean,
    id: String,
  },
  data() {
    return {
      file: null,
    };
  },
  methods: {
    handlePortfolioSelected(e) {
      const file = e.type === "drop" ? e.dataTransfer.files : e.target.files;

      this.$emit("fileUploaded", file[0]);
    },
    preventDefaults(e) {
      e.preventDefault();
    },
    invokeExplorer() {
      document.getElementById(`${this.id}-file-input`).click();
    },
  },
  mounted() {
    events.forEach((eventName) => {
      document.body.addEventListener(eventName, this.preventDefaults);
    });
  },
  unmounted() {
    events.forEach((eventName) => {
      document.body.removeEventListener(eventName, this.preventDefaults);
    });
  },
};
</script>

<style lang="scss" scoped>
.drop-zone {
  width: 100%;
  height: toRem(219);
  border: 1px dashed #779eff;
  border-radius: $inputRadius;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  .controls {
    font-size: toRem(16);
  }
  .btns-container {
    display: flex;
    justify-content: center;
    padding: 17px 0;
    .btn {
      display: block;
      &:first-child {
        margin-right: 20px;
      }
    }
  }

  .spinner-root {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .info {
      font-style: italic;
      text-align: center;
      margin-top: 10px;
      width: 100%;
      color: $inactive;
    }
  }
  .subtle-text {
    font-size: $s-font;
    color: $subtleText;
  }
  .custom-title {
    font-size: $l-font;
  }
}
</style>